const defineTimeOptions = (date) => (
  (!date.getMinutes()) ? (
    { hour: 'numeric' }
  ) : (
    { hour: 'numeric', minute: 'numeric' }
  )
);

export default defineTimeOptions;
